import { graphql } from "react-relay";
import { WeekInReviewScrubber } from "@components/week-in-review-scrubber";

export const suggestionBodyWeekInReviewFragments = {
  suggestionPayload: graphql`
    fragment SuggestionBodyWeekInReview_suggestionPayload on SuggestionResultPayload {
      ... on SuggestionResultWeekInReviewPayload {
        rewindHistory {
          ...WeekInReviewScrubber_rewindHistory
        }
        rewindWeek
      }
    }
  `,
};
